var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("Expanded.Operation.TargetsAndResults.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("Expanded.Operation.TargetsAndResults.Title_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(_vm._s(_vm.$t("Expanded.Operation.TargetsAndResults.Name")))
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("Expanded.Operation.TargetsAndResults.TargetGroup"))
          )
        ]),
        _vm._v(" "),
        _vm.isB || _vm.isC
          ? _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Expanded.Operation.TargetsAndResults.OperationAndOutput_BC"
                  )
                )
              )
            ])
          : _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Expanded.Operation.TargetsAndResults.OperationAndOutput"
                  )
                )
              )
            ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(_vm._s(_vm.$t("Expanded.Operation.TargetsAndResults.Results")))
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("Expanded.Operation.TargetsAndResults.Indicators"))
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("Expanded.Operation.TargetGroup.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$t("Expanded.Operation.TargetGroup.Title_Instructions"))
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("Expanded.Operation.ChangesToTargetsAndResults")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("Expanded.Operation.ChangesToTargetsAndResults_Instructions")
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }